<script lang="ts">
  import WallMasonry from './wall-masonry.svelte';
  import {
    floatingWidgetSettingsStore,
    getFloatingWidgetSettings,
  } from 'src/stores/floating-widget-settings-store';
  import {
    bizReviewStore,
    getBizReviews,
  } from 'src/stores/biz-reviews/biz-review-store';
  import { getTextColorFromBGHex } from 'src/utils/theme-text';
  import DotLoader from 'src/components/loaders/dot-loader.svelte';
  import { trackWallOfLoveLoad } from 'src/utils/telemetry';
  import PoweredBy from 'src/components/powered-by.svelte';

  export let businessKey: string;

  let bizReviews = [];
  let afterCursor = null;
  let loaded = false;
  let isCelebrity = false;
  let isFetchingReviews = false;

  const breakpointCols = {
    default: 6,
    2300: 5,
    1900: 4,
    1500: 3,
    1100: 2,
    700: 1,
  };

  bizReviewStore.subscribe((value) => {
    bizReviews = value.displayData;
    afterCursor = value.after;

    isFetchingReviews = value.loading;
  });

  getBizReviews(businessKey);

  // ==== Widget settings ===
  let themeColor = null;
  $: themeStyle =
    (themeColor &&
      `--primary: ${themeColor}; --theme-text-color: ${getTextColorFromBGHex(
        themeColor,
      )}`) ||
    '';
  getFloatingWidgetSettings(businessKey);

  floatingWidgetSettingsStore.subscribe((value) => {
    themeColor = value.themeColor;
    isCelebrity = value.metaData.celebrity;
  });

  // ==== On Load ===
  function onLoad() {
    if (loaded) return;

    trackWallOfLoveLoad('default', businessKey);
    loaded = true;
  }

  $: {
    if ($floatingWidgetSettingsStore.loaded && bizReviews.length) {
      onLoad();
    }
  }

  /**
   * Fetches more reviews.
   */
  function fetchMoreReviews() {
    getBizReviews(businessKey);
  }
</script>

<div style={themeStyle}>
  {#if loaded}
    <WallMasonry
      reviews={bizReviews}
      {breakpointCols}
      {businessKey}
      {isCelebrity}
    />
  {/if}

  {#if isFetchingReviews}
    <div class="loaderContainer mt-md">
      <DotLoader />
    </div>
  {:else if afterCursor}
    <div class="text-centered mt-md">
      <button class="loadMoreButton rounded-borders" on:click={fetchMoreReviews}
        >Load More</button
      >
    </div>
  {/if}

  {#if loaded}
    <div class="poweredByContainer">
      <PoweredBy class="poweredBy rounded-borders pa-sm mt-md" />
    </div>
  {/if}
</div>

<style lang="scss">
  .wallHeader {
    font-size: 1.25em;
  }

  .wallBusinessName {
    font-size: 2em;
  }

  .loadMoreButton {
    background-color: var(--primary);
    color: var(--theme-text-color);
    border: 1px solid var(--primary);
    padding: 8px;
    cursor: pointer;
  }

  .loaderContainer {
    display: flex;
    justify-content: center;
  }

  .poweredByContainer {
    display: flex;
    justify-content: center;

    :global(.poweredBy) {
      background-color: rgba(255, 255, 255, 0.4);
      backdrop-filter: saturate(180%) blur(20px);
    }
  }
</style>
